import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Form,
  Button,  
  Dropdown,
  Message,  
  Label,
  Tab,
  Modal,
  Radio,
  Icon,
  Card,
  Header
} from 'semantic-ui-react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { mailActions } from '../../actions/mail.actions';
import { textActions } from '../../actions/text.actions';
import { userConstants } from '../../constants/user.constants';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

class EmailEditScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mailTransport: {    
        host: '',
        port: '',
        useSsl: false,
        username: '',
        password: '',
        fromName: '',
        fromAddress: '',
        type: 1,
      },
      mailTest: {
          from: '',
          to: '',
          subject: '[TESTE] E-mail de teste UserLock Addon',
          body: '<p><strong>TESTE</strong></p><p>Teste é um e-mail de teste do Addon do UserLock para controle de acesso</p>'
      },
      text: {
        type: null,
        title: '',
        content: '',
      },
      errors: {},
      submitted: false,
      modalOpen: false
    };    
  }

  componentDidMount() {
    const { dispatch } = this.props;       
    this.fetchTexts();
    dispatch(mailActions.get(1))
            .then(() => {                
                const mailTransport = _.mapKeys(this.props.mailTransport, function (v, k) { return k[0].toLowerCase() + k.substring(1); });                                
                if (mailTransport) {                                        
                    this.setState({ mailTransport })
                }
            });
  }

  static get propTypes() { 
    return {       
        mailTransport: PropTypes.any,
        mailTest: PropTypes.any,
        loading: PropTypes.bool
    }; 
  }

  fetchTexts() {
    const { dispatch } = this.props;    
    dispatch(textActions.fetch());
  }

  handleChange(field, data) {             
    const { mailTransport } = this.state;    
    mailTransport[field] = data;    
    this.setState({ mailTransport });    
  }

  handleChangeTest(field, data) {            
    const { mailTest } = this.state;    
        
    mailTest[field] = data;    
    this.setState({ mailTest });    
  }

  handleChangeText(field, data) {            
    const { text } = this.state;    
        
    text[field] = data;    
    this.setState({ text });    
  }

  handleSubmit() {
    const { dispatch } = this.props;
    const { mailTransport } = this.state;    

    if (mailTransport.id) {
        dispatch(mailActions.update(mailTransport.id, mailTransport));
    } else {
        dispatch(mailActions.create(mailTransport));
    }
  }

  handleTest() {
    const { dispatch } = this.props;
    const { mailTest, mailTransport } = this.state;
    
    dispatch(mailActions.test(mailTransport.id, mailTest));    
  }

  handleText() {
    const { dispatch } = this.props;
    const { text } = this.state;
    
    dispatch(textActions.edit(text.type, text))
      .then(() => {
        this.setState({ modalOpen: false }, () => this.fetchTexts());        
      });    
  }

  openModalText(text) {    
    text = _.mapKeys(text, function (v, k) { return k[0].toLowerCase() + k.substring(1); });
    this.setState({ text, modalOpen: true })
  }

  render() {    
    const { testResult, texts, me } = this.props;
    const { mailTransport, mailTest, errors } = this.state;      

    // Check Permission    
    if (me && me.Role != userConstants.ROLE_ADMIN) {
      window.location.href = "/";
      return;
    }

    const currentText = this.state.text;  
    const typeOptions = [
        { key: 1, value: 1, text: "SMTP" },
        { key: 2, value: 2, text: "Web Service" },
        { key: 3, value: 3, text: "Exchange" },
    ];
    
    const tabSettings = (
      <Tab.Pane>        
        <Form loading={this.props.loading} onSubmit={() => this.handleSubmit()}>
          <Form.Field required>
            <label>Tipo</label>
            <Dropdown
              placeholder='Selecione'
              fluid            
              selection
              onChange={(e, data) => this.handleChange("type", data.value)}
              options={typeOptions}
              value={mailTransport.type} 
            />
            { errors.type && <Label basic pointing  color='red'>{errors.type}</Label>}
          </Form.Field>       

          <Form.Group>
            <Form.Input width={12} required error={errors.host} label='Host' value={mailTransport.host} name='host' type='text' onChange={(e, data) => this.handleChange("host", data.value)} placeholder='' />
            { errors.host && <Label color='red'>{errors.host}</Label>}

            <Form.Input width={4} required error={errors.port} label='Porta' value={mailTransport.port} name='port' type='number' onChange={(e, data) => this.handleChange("port", data.value)} placeholder='' />
            { errors.port && <Label color='red'>{errors.port}</Label>}
          </Form.Group>

          <Form.Input>
            <Radio toggle label='Usar SSL' checked={mailTransport.useSsl} onChange={(e, data) => this.handleChange("useSsl", data.checked)} />
          </Form.Input>

          <Form.Group widths='equal'>
            <Form.Input required error={errors.fromName} label='Endereço Remetente' value={mailTransport.fromAddress} name='fromAddress' type='email' onChange={(e, data) => this.handleChange("fromAddress", data.value)} placeholder='Endereço de e-mail de origem' />
            { errors.fromAddress && <Label color='red'>{errors.fromAddress}</Label>}

            <Form.Input required error={errors.fromName} label='Nome Remetente' value={mailTransport.fromName} name='fromName' type='text' onChange={(e, data) => this.handleChange("fromName", data.value)} placeholder='Nome exibido no remetente dos e-mails' />
            { errors.fromName && <Label color='red'>{errors.fromName}</Label>}
          </Form.Group>
          
          <Form.Group widths='equal'>
            <Form.Input required error={errors.username} label='Username' value={mailTransport.username} name='username' type='text' onChange={(e, data) => this.handleChange("username", data.value)} placeholder='' />
            { errors.username && <Label color='red'>{errors.username}</Label>}

            <Form.Input error={errors.password} label='Senha' value={mailTransport.password} name='password' type='password' onChange={(e, data) => this.handleChange("password", data.value)} placeholder='Deixe em branco para manter' />
            { errors.password && <Label color='red'>{errors.password}</Label>}    
          </Form.Group>

          <Button primary type='submit'>Salvar</Button>                
        </Form>      
      </Tab.Pane>
    )

    const tabTest = (
      <Tab.Pane>        
        <Form loading={this.props.loading} onSubmit={() => this.handleTest()}>
          <Form.Input required error={errors.to} label='Destinatário' value={mailTest.to} name='to' type='email' onChange={(e, data) => this.handleChangeTest("to", data.value)} placeholder='' />
          { errors.to && <Label color='red'>{errors.to}</Label>}

          <Form.Input required error={errors.subject} label='Assunto' value={mailTest.subject} name='subject' type='text' onChange={(e, data) => this.handleChangeTest("subject", data.value)} placeholder='' />
          { errors.subject && <Label color='red'>{errors.subject}</Label>}

          <Form.TextArea required error={errors.body} label='Corpo' value={mailTest.body} name='body' type='text' onChange={(e, data) => this.handleChangeTest("body", data.value)} placeholder='' />
          { errors.body && <Label color='red'>{errors.body}</Label>}

          {testResult && <Message color={testResult.error ? 'red' : 'green'}>{testResult.message}</Message>}                                        
          <Button secondary type='submit'>Enviar e-mail de teste</Button>          
        </Form>
      </Tab.Pane>
    );
    
    const modalText = (
      <Modal closeIcon='close' open={this.state.modalOpen} onClose={() => this.setState({modalOpen: false})}>
      <Modal.Header>{currentText.TypeLabel}</Modal.Header>
      <Modal.Content>                      
        <Modal.Description>      
          <Form>
            <Form.Input required value={currentText.title} label='Título/Assunto' name='title' type='text' onChange={(e, data) => this.handleChangeText("title", data.value)} />        
            <Form.Group>

              <ReactQuill 
                theme="snow" 
                value={currentText.content} 
                style={{ height: '100%', width: '80%' }}
                onChange={(value) => this.handleChangeText('content', value)} />
              
              <Form.Input>
                <Message width={4}>  
                  <Message.Header>Máscaras</Message.Header>
                  <Message.List>
                    <Message.Item><b>[id]</b> - ID da solicitação</Message.Item>
                    <Message.Item><b>[solicitante]</b> - Nome do solicitante</Message.Item>
                    <Message.Item><b>[situacao]</b> - Situação do solicitante</Message.Item>
                    <Message.Item><b>[aprovador]</b> - Nome do aprovador</Message.Item>    
                    <Message.Item><b>[titulo]</b> - Título da solicitação</Message.Item>                
                    <Message.Item><b>[descricao]</b> - Descrição da solicitação</Message.Item>
                    <Message.Item><b>[categoria]</b> - Categoria da solicitação</Message.Item>
                    <Message.Item><b>[projeto]</b> - Projeto da solicitação</Message.Item>
                    <Message.Item><b>[data_inicio]</b> - Data e hora de início do tempo solicitado</Message.Item>
                    <Message.Item><b>[repeticoes]</b> - Quantidade de repetições</Message.Item>
                    <Message.Item><b>[data_aprovado]</b> - Data da aprovação</Message.Item>
                    <Message.Item><b>[justificativa]</b> - Justiticativa rejeição</Message.Item>
                    <Message.Item><b>[tempo_solicitado]</b> - Tempo solicitado (ex: 01:30)</Message.Item>                                        
                    <Message.Item><b>[link_aprovar]</b> - Link para aprovação da solicitação</Message.Item>                                        
                    <Message.Item><b>[link_rejeitar]</b> - Link para rejeitar a solicitação</Message.Item>                                        
                    <Message.Item><b>[link_confirmar]</b> - Link para aprovar ou rejeitar a solicitação</Message.Item>                                        
                  </Message.List>                            
                </Message>
              </Form.Input>
            </Form.Group>          
            <Form.Input>
                <Radio toggle checked={currentText.enabled} label='Habilitado' onChange={(e, data) => this.handleChangeText("enabled", data.checked)} />
            </Form.Input>
            <Button primary type='submit' onClick={() => this.handleText()}>Salvar</Button>                          
          </Form>
        </Modal.Description>
      </Modal.Content>
    </Modal>             
  );
    
    const tabText = (
      <Tab.Pane>                
        {modalText}
        <Card.Group>
          { (!texts || (texts.length == 0)) &&
            <Card header='Nenhum texto' fluid />
          }

          { texts && texts.length > 0 && texts.map((text) => {           
            return <Card key={text.Type} fluid>
              <Card.Content>
                <Card.Header>
                  {text.TypeLabel}
                  <Label style={{float: "right"}} color={text.Enabled ? 'green' : 'red'}>
                    {text.Enabled ? 'Ativo' : 'Inativo'}
                  </Label>
                </Card.Header>
                <Card.Description>
                  <h5>{text.Title}</h5>
                  <p dangerouslySetInnerHTML={{__html: text.Content}}></p>
                </Card.Description>  
              </Card.Content>              
              <Card.Content extra>   
                <Button secondary size='mini' icon onClick={() => this.openModalText(text)}><Icon name='edit' /> Alterar</Button>
              </Card.Content>          
            </Card>                      
          }) }
        </Card.Group>
      </Tab.Pane>
    );

    const panes = [
      { menuItem: 'Configurações', render: () => tabSettings },
      { menuItem: 'Teste de Envio', render: () => tabTest },   
      { menuItem: 'Textos', render: () => tabText },      
    ]

    return <Fragment>
              <Header as='h1'>E-Mail</Header>
              <Tab panes={panes} />    
           </Fragment>
  }
}

function mapStateToProps(state) {
    const { mail, text, users } = state;
    let props = {        
        loading: mail.loading,
        texts: text.texts || null,
        me: users.me || null,
    };
    
    if (mail && mail.item) {
        props.mailTransport = mail.item;    
        props.mailTransport.password = '';  
    }

    props.testResult = mail.testResult;
      
    return props;      
}

const connectedconnectedEmailEditScreen = connect(mapStateToProps)(EmailEditScreen);
export { connectedconnectedEmailEditScreen as EmailEditScreen };
